import { createBrowserRouter, Navigate, Outlet, ScrollRestoration } from 'react-router-dom'
import Home from './pages/Home.tsx'
import PrivacyPage from './pages/Privacy.tsx'
import TermsPage from './pages/Terms.tsx'
import LicensesPage from './pages/Licenses.tsx'
import type { OutputFormat } from './types'

function Root() {
  return (
    <>
      <Outlet />
      <ScrollRestoration />
    </>
  )
}

function toolRoute(path: string, preset: OutputFormat) {
  return {
    path,
    element: <Home preset={preset} />,
  }
}

export const router = createBrowserRouter([
  {
    element: <Root />,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      toolRoute('/heic-to-jpg/', 'jpg'),
      toolRoute('/heic-to-png/', 'png'),
      toolRoute('/heic-to-pdf/', 'pdf'),
      toolRoute('/heic-to-jpg-no-upload/', 'jpg'),
      toolRoute('/batch-converter/', 'jpg'),
      toolRoute('/batch-heic-to-jpg/', 'jpg'),
      toolRoute('/heic-to-jpg-windows-10/', 'jpg'),
      {
        path: '/privacy/',
        element: <PrivacyPage />,
      },
      {
        path: '/terms/',
        element: <TermsPage />,
      },
      {
        path: '/licenses/',
        element: <LicensesPage />,
      },
      {
        path: '*',
        element: <Navigate to="/" replace />,
      },
    ],
  },
])
